import { memo, useEffect, useState } from 'react';
import isEqual from 'lodash.isequal';
import { Typography, Space } from 'antd';
import { FormattedMessage } from 'react-intl';
import { getPlatform } from 'utils/systemUtils';

const { Title, Text } = Typography;

const InvitationComponent: React.FC<any> = (inviteToken, userName) => {
  
  const APKUrl = "https://play.google.com/store/apps/details?id=com.atlasguides.guthook";
  const IOSUrl = "https://apps.apple.com/us/app/farout-formerly-guthook/id605447532";
  //const timeoutDuration = 2000; // 2 seconds

  const [showFallback, setShowFallback] = useState(false);  

  useEffect(() => {
    const platform = getPlatform();

    if (platform === 'android') {
      setShowFallback(true);
      //window.location.href = APKUrl;
      // const timeout = setTimeout(() => {
      //   setShowFallback(true);
      // }, timeoutDuration);
      // return () => clearTimeout(timeout);
    } 
    else if (platform === 'ios') {
      setShowFallback(true);
      console.log('iOS user — no redirect');
    } 
    else {
      setShowFallback(true);
      console.log('Desktop user — no redirect');
    }
  }, []);

  if (!showFallback) {
    // Show nothing while attempting to open the app
    return null;
  }  

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        height: '100vh',
        padding: '32px',
        boxSizing: 'border-box',
        marginTop: '-70px'
      }}
    >
      <Title level={1}>
        <FormattedMessage id="invitation_congratulations" defaultMessage="Congratulations!" />
      </Title>
      <Text style={{ fontSize: '18px', maxWidth: '600px', width: '100%', marginBottom: '24px' }}>
        <FormattedMessage
          id="invitation_info"
          defaultMessage="You have been invited to join the FarOut community. Our outdoor adventure apps feature world-class hiking, biking, and paddling guides from all over the world. Feel secure in your adventure by following our easy-to-use guides, or follow along with another user as they navigate the trail."
        />
      </Text>
      <Space direction="horizontal" size="middle" wrap>
        {/* App Store */}
        { getPlatform() !== 'android' ? (
          <a 
            href={IOSUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/buttons/app-store-badge-small.png"
              alt="Download on the App Store"
              style={{ height: '60px', cursor: 'pointer' }}
            />
          </a>
        ): null}
        
        {/* Google Play */}
        { getPlatform() !== 'ios' ? ( 
          <a 
            href={APKUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/buttons/google-play-badge-small.png"
              alt="Get it on Google Play"
              style={{ height: '60px', cursor: 'pointer'}}
            />
          </a>
        ): null}
      </Space>
    </div>
  );
};

export const InvitationContainer = memo(InvitationComponent, isEqual);
